import { render, staticRenderFns } from "./taskEdit.vue?vue&type=template&id=f3edd0ec"
import script from "./taskEdit.vue?vue&type=script&lang=js"
export * from "./taskEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports